/* global EventTarget */
"use strict";

exports._readEventTarget = function (left) {
  return function (right) {
    return function (foreign) {
      return foreign instanceof EventTarget ? right(foreign) : left("Value is not an EventTarget");
    };
  };
};



//////////////////
// WEBPACK FOOTER
// ./output/DOM.Event.Types/foreign.js
// module id = 539
// module chunks = 0